import { audienceBuilder } from "./audience-builder.reducer";
const audienceBuilderReducer = {
  audienceBuilder
};
export default audienceBuilderReducer;
